import { get, del, put, post } from '../request';

export async function fetchEventGroupings(
  { eventService },
  authenticationToken,
) {
  const url = `${eventService}/events/electroniccorrespondence/eventgroupings`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createEventGrouping(
  { eventService },
  authenticationToken,
  { payload }
) {
  const url = `${eventService}/events/electroniccorrespondence/eventgroupings`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateEventGrouping(
  { eventService },
  authenticationToken,
  { eventGroupingID, payload }
) {
  const url = `${eventService}/events/electroniccorrespondence/eventgrouping/${eventGroupingID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteEventGrouping(
  { eventService },
  authenticationToken,
  { eventGroupingID }
) {
  const url = `${eventService}/events/electroniccorrespondence/eventgrouping/${eventGroupingID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchEventFormPublications(
  { eventService },
  authenticationToken,
) {
  const url = `${eventService}/events/electroniccorrespondence/eventgrouping/publications`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function setGrouping(
  { eventService },
  authenticationToken,
  { payload }
) {
  const url = `${eventService}/events/peventform/publishedeventtypes/setgrouping`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function clearGrouping(
  { eventService },
  authenticationToken,
  { payload }
) {
  const url = `${eventService}/events/peventform/publishedeventtypes/cleargrouping`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchSupportTicketTopics(
  { eventService },
  authenticationToken,
) {
  const url = `${eventService}/queue/electroniccorrespondence/supporttickettopics`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createSupportTicketTopic(
  { eventService },
  authenticationToken,
  { payload }
) {
  const url = `${eventService}/queue/electroniccorrespondence/supporttickettopics`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateSupportTicketTopic(
  { eventService },
  authenticationToken,
  { supportTicketTopicID, payload }
) {
  const url = `${eventService}/queue/electroniccorrespondence/supporttickettopic/${supportTicketTopicID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteSupportTicketTopic(
  { eventService },
  authenticationToken,
  { supportTicketTopicID }
) {
  const url = `${eventService}/queue/electroniccorrespondence/supporttickettopic/${supportTicketTopicID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchSupportTicketTopicsFAQItems(
  { eventService },
  authenticationToken,
  { supportTicketTopicID }
) {
  const url = `${eventService}/queue/electroniccorrespondence/supporttickettopicfaqitems/${supportTicketTopicID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createSupportTicketTopicFAQItem(
  { eventService },
  authenticationToken,
  { supportTicketTopicID, payload }
) {
  const url = `${eventService}/queue/electroniccorrespondence/supporttickettopicfaqitems/${supportTicketTopicID}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateSupportTicketTopicFAQItem(
  { eventService },
  authenticationToken,
  { supportTicketTopicFAQItemID, payload }
) {
  const url = `${eventService}/queue/electroniccorrespondence/supporttickettopicfaqitem/${supportTicketTopicFAQItemID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteSupportTicketTopicFAQItem(
  { eventService },
  authenticationToken,
  { supportTicketTopicFAQItemID }
) {
  const url = `${eventService}/queue/electroniccorrespondence/supporttickettopicfaqitem/${supportTicketTopicFAQItemID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}